var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url || _vm.paymentMethod)?_c('i',{staticClass:"custom-icon v-icon",class:_vm.customClasses,style:(_vm.styles)}):(_vm.$slots.default)?_c('VIcon',_vm._g(_vm._b({},'VIcon',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }